
import { api } from '@/scripts/api';

export const APIKeysService = {
    getAll(config = {}, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/openapi-admin/v1/keys/${accountId}`;
            const endpoint = api.applyNodeDataParams(service, config);
            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    getById(accountId, keyId) {
        return new Promise((resolve, reject) => {
            const endpoint = `/ms/openapi-admin/v1/keys/${keyId}/${accountId}`;

            api.get(endpoint).then(resolve).catch(reject);
        })
    },

    delete(accountId, keyId) {
        return new Promise((resolve, reject) => {
            const endpoint = `/ms/openapi-admin/v1/keys/${keyId}/${accountId}`;

            api.delete(endpoint).then(resolve).catch(reject);
        })
    },

    createAPIKey(accountId, body) {
        const service = `/ms/openapi-admin/v1/keys/${accountId}`;
        return new Promise((resolve, reject) => {
            api.post(service, body).then(resolve).catch(reject);
        })
    },
    
    editAPIKey(accountId, keyId, body) {
        const service = `/ms/openapi-admin/v1/keys/${keyId}/${accountId}`;
        return new Promise((resolve, reject) => {
            api.put(service, body).then(resolve).catch(reject);
        })
    }
}